/** Фиксированная высота десктопного listbox (список и пустое состояние). */
export const SUGGEST_DESKTOP_LISTBOX_HEIGHT = 370;

export const SUGGEST_PROP_DEFAULTS = {
  maxLines: 3,
  maxHeight: SUGGEST_DESKTOP_LISTBOX_HEIGHT,
  itemType: 'default',
} as const;
export const SUGGEST_ITEM_FLEX_GAP_SIZE = 12;
export const SUGGEST_MINIMUM_CHARACTERS_FOR_HIGHLIGHT_TO_WORK = 2;
